import { InfoOutlined } from "@mui/icons-material";
import {
  Button,
  CardActions,
  CircularProgress,
  FormControl,
  FormHelperText,
  Grid,
  MenuItem,
  TextField,
} from "@mui/material";
import Select from "@mui/material/Select";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";
import { FiChevronDown } from "react-icons/fi";

import { CustomerPortalModal, CustomerPortalModalCard } from "../../../CustomerPortalModal";

export const Modal = styled(CustomerPortalModal)(() => ({}));

export const ModalCard = styled(CustomerPortalModalCard)(({ theme }) => ({
  width: "100%",
  [theme.breakpoints.up("md")]: {
    maxWidth: "628px",
  },
}));

export const ModalBody = styled("div")(() => ({
  width: "100%",
  height: "100%",
}));

export const ModalHeader = styled(Grid)(() => ({
  padding: "24px 24px 16px",
}));

export const ModalHeaderContainer = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
}));

export const LeftHeaderBox = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
}));

export const ModalTitle = styled("span")(() => ({
  font: "800 20px Manrope",
  lineHeight: "28px",
  color: colors.black,
}));

export const ContainerIcon = styled("div")(({ theme }) => ({
  borderRadius: "40px",
  alignItems: "center",
  justifyContent: "center",
  height: "40px",
  width: "40px",
  display: "flex",
  marginRight: "16px",
  backgroundColor: theme.palette.secondary.main,
}));

export const Body = styled(Grid)(() => ({
  padding: "0 24px 24px",
  maxHeight: "calc(90vh - 194px)",
  overflow: "hidden auto",
}));

export const MFormControl = styled(FormControl)(({ theme, error, disabled }) => ({
  width: "100%",

  "& fieldset": {
    borderColor: `${error ? colors.error600 : colors.gray300}`,
  },

  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: `${
      // eslint-disable-next-line no-nested-ternary
      disabled ? "none" : error ? colors.error600 : theme.palette.primary.main
    } !important`,
  },
  "& .MuiSelect-select:focus": {
    backgroundColor: "transparent",
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: `${error ? colors.error600 : theme.palette.primary.main}`,
  },
}));

export const SelectField = styled(Select, {
  shouldForwardProp(propName) {
    return propName !== "fullWidth";
  },
})(({ disabled }) => ({
  backgroundColor: disabled ? colors.gray50 : colors.white,
  height: "40px",
  borderRadius: "8px !important",
  display: "flex",
  alignItems: "center",
}));

export const SelectOption = styled(MenuItem)(() => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "flex-start !important",
  alignSelf: "stretch",
}));

export const PlaceholderText = styled("span")(() => ({
  color: colors.gray500,
  font: "400 14px Manrope",
  lineHeight: "20px",
  letterSpacing: "0.25px",
}));

export const OptionTitle = styled("span")(() => ({
  color: colors.gray600,
  font: "400 16px Manrope",
  lineHeight: "24px",
  letterSpacing: "0.5px",
}));

export const OptionName = styled("span")(() => ({
  color: colors.gray500,
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  overflow: "hidden",
  font: "400 14px Manrope",
  lineHeight: "20px",
  letterSpacing: "0.25px",
}));

export const FieldLabel = styled("span")(({ theme }) => ({
  font: "600 14px Manrope",
  lineHeight: "20px",
  letterSpacing: "0.1px",
  color: theme.palette.primary.main,
}));

export const Required = styled("span")(() => ({
  color: colors.error500,
}));

export const SelectIcon = styled(FiChevronDown)(() => ({
  marginRight: "5px",
}));

export const TextAreaField = styled(TextField)(({ disabled }) => ({
  "& .MuiOutlinedInput-root": {
    backgroundColor: disabled ? colors.gray50 : colors.white,
    borderRadius: "8px",
    color: colors.gray500,
    font: "400 14px Manrope",
    lineHeight: "20px",
    letterSpacing: "0.25px",
  },
}));

export const ModalFooter = styled(Grid)(() => ({
  padding: "16px 24px",
  display: "flex",
  justifyContent: "flex-end",
}));

export const SendButton = styled(Button)(({ theme, disabled }) => ({
  padding: "10px 20px",
  font: "600 14px Manrope",
  letterSpacing: "0.1px",
  textTransform: "none",
  backgroundColor: disabled ? colors.gray300 : theme.palette.primary.main,
  borderRadius: "8px",
  color: colors.white,
  lineHeight: "20px",

  "&:hover": {
    backgroundColor: `${theme.palette.primary.main}DB`,
  },
}));

export const CancelButton = styled(Button)(() => ({
  padding: "10px 20px",
  font: "600 14px Manrope",
  letterSpacing: "0.1px",
  textTransform: "none",
  borderRadius: "8px",
  color: colors.gray600,
  lineHeight: "20px",
}));

export const ModalActions = styled(CardActions)(() => ({ padding: 0 }));

export const NotifyContainer = styled("div")(() => ({
  display: "flex",
  padding: "4px 12px",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "4px",
  borderRadius: "12px",
  backgroundColor: colors.gray50,
  color: colors.gray600,
  font: "400 14px Manrope",
  lineHeight: "20px",
  letterSpacing: "0.25px",
  marginTop: "10px",
}));

export const NotifyInfo = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "2px",
}));

export const NotifyContact = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  alignSelf: "stretch",
}));

export const ErrorContainer = styled(FormHelperText)(() => ({
  font: "400 14px Manrope",
  lineHeight: "24px",
  color: colors.error600,
  alignItems: "center",
  display: "flex",
  margin: 0,
}));

export const ErrorIcon = styled(InfoOutlined)(() => ({
  marginRight: "5px",
}));

export const LoadingSpinner = styled(CircularProgress)(() => ({
  color: colors.white,
}));

export const NotifyInfoFields = styled(Grid)(() => ({
  display: "flex",
  alignItems: "flex-end",
}));
